// extracted by mini-css-extract-plugin
module.exports = {"btn-menu":"MenuAccordion_btn-menu__1MvS6"};